"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var MoveTransform_1 = require("./MoveTransform");

var AddTransform_1 = require("./AddTransform");

var DeleteTransform_1 = require("./DeleteTransform");

var ValueTransform_1 = require("./ValueTransform");

var MigrationTransform =
/** @class */
function () {
  function MigrationTransform(transform) {
    this.transform = transform;
  }

  MigrationTransform.prototype.execute = function (seed, direction) {
    var transformInstance;

    switch (this.transform.type) {
      case 'add':
        transformInstance = new AddTransform_1.AddTransform(this.transform.options);
        break;

      case 'delete':
        transformInstance = new DeleteTransform_1.DeleteTransform(this.transform.options);
        break;

      case 'move':
        transformInstance = new MoveTransform_1.MoveTransform(this.transform.options);
        break;

      case 'value':
        transformInstance = new ValueTransform_1.ValueTransform(this.transform.options);
        break;
    }

    var result = seed;

    if (transformInstance) {
      result = transformInstance[direction](seed);
    }

    return result;
  };

  return MigrationTransform;
}();

exports.MigrationTransform = MigrationTransform;